import axios from 'axios';
import * as lodash from 'lodash';
import * as utilCommon from './helpers/util-common';
import { setCookie } from 'helpers/manageCookies';
import getApiUrl from 'helpers/api-urls';
import { isEmpty } from 'lodash';
import { cookieKeysEnum, USER_INFO, IDENTITY_DELEGATION_FLAG } from 'models/common.models';
import { oktaErrorLoginHandler } from 'helpers/OktaUtility';

let delegation = utilCommon.cacheManager.getItem(USER_INFO) ? lodash.get(JSON.parse(utilCommon.cacheManager.getItem(USER_INFO)), IDENTITY_DELEGATION_FLAG) : null;
let IdentityDelegationUserId = window.btoa(delegation?.proxyMemberUserId);
let IdentityDelegation = window.btoa(JSON.stringify(delegation));

// eslint-disable-next-line no-unused-vars
const setupInterceptors = (store) => {
	// All Interceptor Request
	axios.interceptors.request.use(async (config) => {
		config.headers['s-origin'] = window.location.origin
		config.headers.SecurityKey = process.env.REACT_APP_OPEN_SECURITY_KEY;
		if (delegation?.proxyMemberUserId) {
			config.headers['IdentityDelegationUserId'] = IdentityDelegationUserId;
			config.headers['IdentityDelegation'] = IdentityDelegation;
		}

		//MAE Call to get Member Account Number if _MyASTM Cookie not available except meeting public page
		let current_page = window.location.pathname.replace(/\/$/, "");
		let public_pages = ['/meeting','/meeting/event','/meeting/search-keyword' ];
		
		if (public_pages.indexOf(current_page) < 0)
		{
			const memAccNumberFromCookie = utilCommon.getMemberAccountNo();
			if (!memAccNumberFromCookie) {
			    const oktaToken = window.localStorage.getItem('okta-token-storage') ? JSON.parse(window.localStorage.getItem('okta-token-storage')) : false;
				const MAEUserID = oktaToken?.idToken?.claims?.MAEUserID;
				if (MAEUserID) {
					const requestBody = {
						MAEUserID: oktaToken?.idToken?.claims?.MAEUserID
					}
					let headerInfo = {
						method: 'POST',
						body: JSON.stringify(requestBody),
						headers: new Headers({
							'Content-Type': 'application/json;charset=utf-8',
							'Authorization': _.get(oktaToken, 'idToken.idToken')
						})
					}
					const url = getApiUrl('MAE', 'getAccountNumber');
					await fetch(url, headerInfo).then(response => response.json()).then(response => {
						if (response && response.ResponseStatus == "Success" && !isEmpty(response.ResponseData)) {
							setCookie(cookieKeysEnum["_MyASTM"], response.ResponseData, process.env.REACT_APP_COOKIES_EXPIRATION_TIME);
						}
					})
					.catch((error) => {
						console.log("Exception in MAE Call to fetch Account number", error);
					})
				} else {
					oktaErrorLoginHandler();
				}
			}
		}
		
		if (window.localStorage.getItem('storeUUIDForAllApiCall') === "" || window.localStorage.getItem('storeUUIDForAllApiCall') === null) {
			window.localStorage.setItem('storeUUIDForAllApiCall', JSON.stringify({}));
		}
		let generateUUIDForApiCall = utilCommon.generateUUID(true);
		let storeUUIDArray = JSON.parse(window.localStorage.getItem('storeUUIDForAllApiCall'));
		let newStoreUUIDArray = { ...storeUUIDArray };
		newStoreUUIDArray[config.url] = generateUUIDForApiCall;
		window.localStorage.setItem('storeUUIDForAllApiCall', JSON.stringify(newStoreUUIDArray));
		config.headers.uniquerequestid = generateUUIDForApiCall;
		return config;
	})

	// All Interceptor Response
	axios.interceptors.response.use((response) => {
		if (response && response.data) {
			// Validate Data is in String Format
			if (lodash.isString(response.data)) {
				// Parse JSON for security
				let updateData = response.data.replace(')]}', '')
				response.data = JSON.parse(updateData)
			}
		}
		return response
	}, (error) => {
		return Promise.reject(error)
	})

}

export default setupInterceptors


